import { render, staticRenderFns } from "./WizardDetails.vue?vue&type=template&id=1e0e5ad2&"
import script from "./WizardDetails.vue?vue&type=script&lang=js&"
export * from "./WizardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports